import { render } from "./EditMenu.vue?vue&type=template&id=00c216bf&lang=pug"
import script from "./EditMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__